import * as React from 'react'

import { FormGroup, FormItem } from 'main/components/common/Form'
import { DateTextField } from 'main/ui'
import { IParams, IValidation } from './types'

interface IProps {
  params: IParams
  validation: IValidation
  onChange: (changes: Partial<IParams>) => void
}

export default function Fields(props: IProps) {
  const { params, validation, onChange } = props

  return (
    <FormItem label="Tell us about your child care or preschool needs">
      <FormGroup>
        <DateTextField
          label="Child's date of birth"
          placeholder="Child's date of birth"
          value={params.birthday}
          onChange={birthday => onChange({ birthday })}
          validationHint={validation.birthday}
          required
        />

        <DateTextField
          label="Desired start date"
          placeholder="Desired start date"
          value={params.desiredEnrollmentDate}
          onChange={desiredEnrollmentDate => onChange({ desiredEnrollmentDate })}
          validationHint={validation.desiredEnrollmentDate}
          required
        />
      </FormGroup>
    </FormItem>
  )
}
